module.exports = __webpack_public_path__ + "img/admin-a4.b4240780.png";